/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_Check1Inputs */

const en_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All trees you've unlocked`)
};

const ar_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الأشجار التي فتحتها`)
};

const de_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Bäume, die Sie freigeschaltet haben`)
};

const es_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los árboles que has desbloqueado`)
};

const fr_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous vos arbres débloqués`)
};

const it_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti gli alberi che hai sbloccato`)
};

const ja_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これまでにアンロックしたすべての木`)
};

const ko_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`획득한 모든 나무`)
};

const pt_br_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as árvores que você desbloqueou`)
};

const ru_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все разблокированные вами деревья`)
};

const th_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้ทั้งหมดที่คุณปลดล็อกแล้ว`)
};

const tr_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilidini açtığın tüm ağaçlar`)
};

const zh_cn_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有已解锁树种`)
};

const zh_tw_pro_user_appreciation_letter_commitment_check1 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Check1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有已解鎖樹種`)
};

/**
* | output |
* | --- |
* | "All trees you've unlocked" |
*
* @param {Pro_User_Appreciation_Letter_Commitment_Check1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_check1 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_Check1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_Check1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_check1(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_check1(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_check1(inputs)
});